import { render } from "./FooterWelcom.vue?vue&type=template&id=8319830c"
import script from "./FooterWelcom.vue?vue&type=script&lang=js"
export * from "./FooterWelcom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__